import React from 'react';
import { render } from '@testing-library/react';

it('should render with the correct text', () => {
  //const { getByText } = render(<BasicAntForm />);
  //const rendered = getByText('hello from AntForm');
  expect(true).toBeTruthy();
});
